import { useTranslation } from "react-i18next";
import { PublicClinicShell } from "./components/PublicClinicShell";

export function TermsAndConditionsPage() {
  const { t } = useTranslation(["landing"]);

  return (
    <PublicClinicShell
      seo={{
        title: t("landing:seo.terms_title"),
        description: t("landing:seo.terms_description"),
        path: "/terms-and-conditions",
      }}
    >
      <main className="flex-grow max-w-3xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold tracking-tight mb-2">
          {t("landing:terms.title")}
        </h1>
        <p className="text-sm text-muted-foreground mb-8">
          {t("landing:terms.updated")}
        </p>

        <div className="space-y-6 text-card-foreground/90 leading-relaxed text-justify">
          <p>{t("landing:terms.intro")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:terms.section1_title")}
          </h2>
          <p>{t("landing:terms.section1_body_a")}</p>
          <p>{t("landing:terms.section1_body_b")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:terms.section2_title")}
          </h2>
          <p>{t("landing:terms.section2_body_a")}</p>
          <p>{t("landing:terms.section2_body_b")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:terms.section3_title")}
          </h2>
          <p>{t("landing:terms.section3_body")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:terms.section4_title")}
          </h2>
          <p>{t("landing:terms.section4_body")}</p>

          <h2 className="text-xl font-semibold text-foreground pt-4">
            {t("landing:terms.section5_title")}
          </h2>
          <p>{t("landing:terms.section5_body")}</p>
        </div>
      </main>
    </PublicClinicShell>
  );
}
